<template>
    <div class="lx-online-booking-checkout-review-policies">
        <card
            v-if="website"
        >
            <template #header-icon>
                <font-awesome-icon
                    :icon="['fas', 'file-signature']"
                    size="lg"
                />
            </template>
            <template #header-content> Terms And Conditions </template>
            <template #body>
                <div class="lx-online-booking-checkout-review-policies__reservations-policies">
                    <online-booking-reservation-policies 
                        v-for="techReservation in reservation.tech_reservations" 
                        :key="techReservation.id"
                        :techReservation="techReservation" 
                        class="lx-online-booking-checkout-review-policies__reservations-policies__reservation-policies"
                    />
                </div>
                <div class="lx-online-booking-checkout-review-policies__deposit-policy">
                    <h4>Deposit Policy</h4>
                    <p v-html="depositPolicy" />
                </div>
                <div class="lx-online-booking-checkout-review-policies__cancellation-policy">
                    <h4>Cancellation Policy</h4>
                    <p v-html="cancellationPolicy" />
                </div>
                <validation-provider
                    name="policy"
                    rules="required"
                    v-slot="{ errors, handleChange }"
                    validate-on-mount
                >
                    <form-checkbox
                        v-model="isAgree"
                        :error="errors[0]"
                        :invalid-feedback="''"
                        @change="handleChange"
                        size="lg"
                    >
                        <span class="lx-online-booking-checkout-review-policies__agree-checkbox-text">
                            I have read, and I understand, the terms and conditions of this property.
                        </span>
                    </form-checkbox>
                </validation-provider>
            </template>
        </card>
    </div>
</template>

<script>
import DOMPurify from 'dompurify';
import { mapGetters, mapMutations } from 'vuex';
import Card from '../../../generic/card/card.vue';
import FormCheckbox from '../../../generic/form-checkbox/form-checkbox.vue';
import OnlineBookingReservationPolicies from './online-booking-reservation-policies.vue';

export default {
    components: {
        Card,
        FormCheckbox,
        OnlineBookingReservationPolicies
    },
    computed: {
        ...mapGetters('onlineBooking', ['website', 'reservation', 'client',]),
        isAgree: {
            get() {
                return this.client.is_agreed
            },
            set(value) {
                this.setClientIsAgreed(value)
            }
        },
        depositPolicy() {
            return DOMPurify.sanitize((this.website.deposit_policy || '').split('\n').join('<br/>'), {
                ALLOWED_TAGS: ['a', 'b', 'strong', 'i', 'p', 'br'],
                ALLOWED_ATTR: ['href', 'target']
            });
        },
        cancellationPolicy() {
            return DOMPurify.sanitize(
                (this.reservation.cancellation_policy.description || '').split('\n').join('<br/>'),
                {
                    ALLOWED_TAGS: ['a', 'b', 'strong', 'i', 'p', 'br'],
                    ALLOWED_ATTR: ['href', 'target'],
                }
            );
        }
    },
    methods: {
        ...mapMutations('onlineBooking', ['setClientIsAgreed']),
    }
}
</script>

<style lang="scss" scoped>
    .lx-online-booking-checkout-review-policies {
        &__reservations-policies {
            margin-bottom: 2rem;
            &__reservation-policies {
                margin-bottom: 2rem;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
        &__deposit-policy, &__cancellation-policy {
            margin-bottom: 2rem;
            h4 {
                font-size: 14px;
                font-weight: bold;
                line-height: 1;
                margin-bottom: 0;
            }
            p {
                font-size: 14px;
                margin-top: 5px;
                line-height: 1.5;
                margin-bottom: 0;
                white-space: pre-line;
            }
        }
        &__agree-checkbox-text {
            font-size: 16px;
            font-weight: bold;
        }
    }
</style>
